export default __webpack_public_path__ + "static/media/1688.8e284e7f.png";